export enum Currency {
  GBP = '£',
}
